//#region Imports 

import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { IconComponent } from '../../components/icon/icon.component';
import { OutsideClick } from '../../directives/outside-click/outside-click.directive';
import { ToastService } from '../../components/toast/service/toast.service';
import { getErrorMessage } from '../../utils/functions';

//#endregion

//#region Interfaces

export interface ModalAction {
  label: string;
  icon: string;
  callback?: (event: Event) => void | Promise<void>;
  colorClass?: string;
  disabled?: boolean;
}

//#endregion

@Component({
  selector: 'l-modal-options',
  standalone: true,
  imports: [ConfirmPopupModule, IconComponent, NgClass, OutsideClick],
  templateUrl: './modal-options.component.html',
  providers: [ToastService]
})
export class ModalOptionsComponent {

  //#region Constructor

  constructor(private toastService: ToastService) {}

  //#endregion

  //#region Public Properties

  @Input({ required: true }) 
  public actions: ModalAction[] = [];

  @Input() 
  public id?: string;

  @Output() 
  public close: EventEmitter<void> = new EventEmitter<void>();

  @Output() 
  public delete: EventEmitter<void> = new EventEmitter<void>();

  //#endregion

  //#region Public Methods

  public async handleAction(action: ModalAction, event: Event): Promise<void> {
    if (!action.callback) {
      this.close.emit();
      return;
    }

    const result = action.callback(event);

    if (result && typeof (result as any).then === 'function') {
      try {
        await (result as unknown as Promise<void>);
      } catch (error) {
        this.toastService.error(getErrorMessage(error), 'Oops...');
      } finally {
        this.close.emit()
      }
    }
  }

  public trackBy(index: number): number {
    return index;
  }

  //#endregion
}